import * as React from "react";
const IconMicOff = (props) => (
  <svg
    width={21}
    height={22}
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.6646 18V21M10.6646 18C6.79856 18 3.66455 14.866 3.66455 11V10M10.6646 18C12.6972 18 14.5275 17.1336 15.8063 15.75M10.6646 21H13.6646M10.6646 21H7.66455M1.66455 1.75L19.6646 19.75M17.6646 10V11C17.6646 11.8232 17.5224 12.6132 17.2614 13.3469M14.6646 10.75V5C14.6646 2.79086 12.8737 1 10.6646 1C9.10897 1 7.76079 1.88797 7.09924 3.18469M6.66455 7V11C6.66455 13.2091 8.45541 15 10.6646 15C11.813 15 12.8483 14.516 13.5778 13.741"
      stroke="#6D6E75"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconMicOff;
